import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { config } from '../app.config';

@Component({
  selector: 'ch-new-admin-redirect',
  templateUrl: './new-admin-redirect.component.html',
  styleUrls: ['./new-admin-redirect.component.css']
})
export class NewAdminRedirectComponent implements OnInit, OnDestroy {
  public breadcrumb: string[] = [];
  public pageTitle: string;
  public newAdminUrl: string;

  private queryParamsSub: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly titleService: Title
  ) {}

  ngOnInit() {
    const defaultPath = this.route.snapshot.data['pagePath'];

    if (!defaultPath) {
      // Temporary compatibility: the modern portal owns unknown routes while this portal is being retired.
      const productionAdminUrl = window.location.hostname === 'legacy.admin.codehospitality.co.uk'
        ? 'https://admin.codehospitality.co.uk'
        : config.new_admin_url;
      window.location.replace(`${productionAdminUrl}${window.location.pathname}${window.location.search}${window.location.hash}`);
      return;
    }

    this.pageTitle = this.route.snapshot.data['pageTitle'];
    this.titleService.setTitle(`${this.pageTitle} | CODE Hospitality CMS`);
    this.breadcrumb = [this.pageTitle];

    this.queryParamsSub = this.route.queryParams.subscribe(params => {
      const pagePath = this.buildPagePath(defaultPath, params);
      const baseUrl = config.new_admin_url || 'https://code-staging-cms-vue.on.dev-craft.tech';
      this.newAdminUrl = `${baseUrl}${pagePath}`;
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe();
    }
    this.titleService.setTitle('CODE Hospitality CMS');
  }

  public navigateToNewAdmin() {
    window.open(this.newAdminUrl, '_blank');
  }

  private buildPagePath(defaultPath: string, params: {[key: string]: string}): string {
    const routePath = this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path;

    if (routePath === 'offers/add' || routePath === 'offers/edit') {
      return this.buildOfferPath(routePath, params);
    }

    if (routePath === 'ab-tests/add') {
      return '/ab-tests?create=true';
    }

    if (routePath === 'ab-tests/edit') {
      return params['id'] ? `/ab-tests/${encodeURIComponent(params['id'])}` : '/ab-tests?create=true';
    }

    return defaultPath;
  }

  private buildOfferPath(routePath: string, params: {[key: string]: string}): string {
    const duplicateId = params['duplicateId'];
    const duplicateName = params['duplicateName'];
    const editId = params['editId'] || params['id'];

    if (routePath === 'offers/edit' && editId && !duplicateId) {
      return `/offers/${encodeURIComponent(editId)}`;
    }

    const queryParts: string[] = [];
    if (duplicateId) {
      queryParts.push(`duplicateId=${encodeURIComponent(duplicateId)}`);
    }
    if (duplicateName) {
      queryParts.push(`duplicateName=${encodeURIComponent(duplicateName)}`);
    }

    if (routePath === 'offers/edit' && !duplicateId) {
      return '/offers';
    }

    return queryParts.length ? `/offers/new?${queryParts.join('&')}` : '/offers/new';
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/new-admin-redirect/new-admin-redirect.component.ts